import { BarChart3, GraduationCap, Plane, Shield, Users, Zap } from 'lucide-react'
import React from 'react'


const Industry = () => {
  return (
    <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center space-x-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm mb-6">
              <Shield className="w-4 h-4" />
              <span>Industry Solutions</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Trusted across industries
            </h2>
            <p className="text-xl text-gray-600">
              Secure, compliant, and scalable messaging solutions tailored for
              regulated and high-growth industries
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-blue-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <Shield className="w-5 h-5 text-blue-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                Banking & Finance
              </h3>
              <p className="text-sm text-gray-600">
                Secure transaction alerts, fraud notifications, and customer
                support with bank-grade security
              </p>
            </div>

            <div className="bg-green-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <Users className="w-5 h-5 text-green-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Healthcare</h3>
              <p className="text-sm text-gray-600">
                HIPAA-compliant appointment reminders, prescription alerts, and
                patient communication
              </p>
            </div>

            <div className="bg-purple-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <Zap className="w-5 h-5 text-purple-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Fintech</h3>
              <p className="text-sm text-gray-600">
                Real-time payment confirmations, security alerts, and seamless
                onboarding experiences
              </p>
            </div>

            <div className="bg-orange-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <BarChart3 className="w-5 h-5 text-orange-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">E-commerce</h3>
              <p className="text-sm text-gray-600">
                Order updates, delivery notifications, and personalized
                marketing campaigns
              </p>
            </div>

            <div className="bg-teal-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <Users className="w-5 h-5 text-teal-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Insurance</h3>
              <p className="text-sm text-gray-600">
                Policy renewals, claim updates, and emergency notifications with
                regulatory compliance
              </p>
            </div>

            <div className="bg-indigo-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mb-4">
                <Plane className="w-5 h-5 text-indigo-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">
                Travel & Hospitality
              </h3>
              <p className="text-sm text-gray-600">
                Booking confirmations, travel updates, and guest communication
                across global markets
              </p>
            </div>

            <div className="bg-pink-50 p-6 rounded-xl">
              <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center mb-4">
                <GraduationCap className="w-5 h-5 text-pink-600" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Education</h3>
              <p className="text-sm text-gray-600">
                Student communications, parent notifications, and campus alerts
                with privacy protection
              </p>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Industry